module.exports = __webpack_public_path__ + "img/xblaster.d62f817e.png";